import React from "react";
import { Card, Space } from "antd";
import { BlockConfig } from "../types";
import { BlockRenderer } from "../blocks/BlockRenderer";
import styles from "../../components/topicfeed.module.css";
import { tagBlock } from "../blocks/TagBlock";
import { AnnotatedDeepLink } from "pages/api/deep-links/types";
import { DigestV2State } from "pages/api/deep-links/types";

interface CompositeCardRendererProps {
  data: any;
  blocks: BlockConfig[];
  size?: "mini" | "expanded";
  className?: string;
  style?: React.CSSProperties;
  link: AnnotatedDeepLink<DigestV2State>;
  processedRecords: number;
  totalRecords: number;
}

export const CompositeCardRenderer: React.FC<CompositeCardRendererProps> = ({
  data,
  blocks,
  size = "expanded",
  link,
  processedRecords,
  totalRecords,
  className,
  style,
}) => {
  if (!data || Object.keys(data).length === 0) return <div>No data found</div>;

  const headerBlocks = blocks.filter((block) => block.type === `${size}Header`);
  const bodyBlocks = blocks.filter((block) => block.type === `${size}Body`);
  const footerBlocks = blocks.filter((block) => block.type === `${size}Footer`);

  const headerProps = {
    link,
    size,
    processedRecords,
    totalRecords,
    data,
  };

  const bodyProps = {
    link,
    size,
    data,
  };

  const footerProps = {
    link,
    size,
    data,
    tags: data[tagBlock.id] || [], //TODO: this is a hack to get the tags from the data
    processedRecords,
    totalRecords,
  };

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      {headerBlocks?.length > 0 && (
        <div className={styles.header}>
          {headerBlocks.map((block: any, index: number) => (
            <BlockRenderer
              key={index}
              blockConfig={block}
              renderProps={headerProps}
            />
          ))}
        </div>
      )}
      {bodyBlocks?.map((block: any, index: number) => (
        <BlockRenderer
          key={`body-${block.id}-${index}`}
          blockConfig={block}
          renderProps={bodyProps}
        />
      ))}
      {footerBlocks?.length > 0 && (
        <div className={styles.footer}>
          {footerBlocks.map((block: any, index: number) => (
            <BlockRenderer
              key={index}
              blockConfig={block}
              renderProps={footerProps}
            />
          ))}
        </div>
      )}
    </Space>
  );
};
